// src/.../Sidebar.jsx
import React from "react";
import { X } from "lucide-react";
import styles from "./Sidebar.module.css";
import { IMAGES } from "../../../../config/supabaseImages"; // ajustá la ruta si tu estructura difiere

function Sidebar({ tabs = [], activeTab, onSelect, isOpen = false, onClose }) {
  // Logo público desde IMAGES con fallback inline SVG
  const logoSrc = IMAGES?.logos?.logoNegroSintesis || IMAGES?.logos?.logoNegro || '';

  const PLACEHOLDER_LOGO =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="60" viewBox="0 0 120 60"><rect width="100%" height="100%" fill="none"/><text x="50%" y="50%" fill="#ffffff" font-family="Arial, sans-serif" font-size="16" font-weight="bold" dominant-baseline="middle" text-anchor="middle">SC</text></svg>`
    );

  const handleLogoError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER_LOGO;
    e.currentTarget.alt = 'Logo (fallback)';
  };

  return (
    <>
      <div
        className={`${styles.overlay} ${isOpen ? styles.open : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside
        className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}
        aria-label="Navegación de administración"
      >
        <div className={styles.brand}>
          <img
            src={logoSrc || PLACEHOLDER_LOGO}
            alt="Sole Costilla Group"
            className={styles.logo}
            onError={handleLogoError}
            loading="lazy"
          />
          <div className={styles.brandText}>
            <span className={styles.brandName}>Sole Costilla</span>
            <span className={styles.brandRole}>Administración</span>
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Cerrar menú"
          >
            <X size={18} aria-hidden="true" />
          </button>
        </div>

        <nav className={styles.nav} aria-label="Secciones del panel">
          <span className={styles.navLabel}>Panel</span>
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                className={`${styles.navButton} ${isActive ? styles.active : ""}`}
                onClick={() => onSelect?.(tab.id)}
                aria-current={isActive ? "page" : undefined}
              >
                <span className={styles.navIcon}>
                  {Icon ? <Icon size={18} aria-hidden="true" /> : null}
                </span>
                <span className={styles.navText}>{tab.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
